import AccessDenied from "./Index";

export const accessDeniedRoutes = (data) => [
  {
    path: "/:lang/accessDenied",
    title: "Access Denied",
    layout: "front",
    routeType: ["user", "organization"].includes(data?.user?.role)
      ? data?.user?.role
      : "user",
    component: AccessDenied,
  },
];
